import { useState, useEffect, useCallback } from 'react';

/**
 * 사용자 인증 상태 및 세션을 관리하는 커스텀 훅
 */
export const useAuth = () => {
  const [token, setToken] = useState(sessionStorage.getItem('token'));
  const [userRole, setUserRole] = useState(sessionStorage.getItem('userRole'));

  // 초기 로드 시 localStorage 데이터가 있다면 sessionStorage로 마이그레이션 (기존 App.js 로직 유지)
  useEffect(() => {
    const oldToken = localStorage.getItem('token');
    if (oldToken && !token) {
      sessionStorage.setItem('token', oldToken);
      sessionStorage.setItem('userRole', localStorage.getItem('userRole') || 'user');
      setToken(oldToken);
      setUserRole(localStorage.getItem('userRole') || 'user');
      
      // 마이그레이션 후 정리
      localStorage.removeItem('token');
      localStorage.removeItem('userRole');
    }
  }, [token]);

  // 로그인 성공 처리
  const login = useCallback((newToken, role) => {
    sessionStorage.setItem('token', newToken);
    sessionStorage.setItem('userRole', role);
    setToken(newToken);
    setUserRole(role);
  }, []);

  // 로그아웃 처리
  const logout = useCallback(() => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('userRole');
      setToken(null);
      setUserRole(null);
      return true;
    }
    return false;
  }, []);

  return {
    token,
    userRole,
    isAuthenticated: !!token,
    isAdmin: userRole === 'admin',
    login,
    logout
  };
};